import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {errorRaised} from "@mnjsplatform/data/lib/actions/errorActions";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import SalaryRequest from "./SalaryRequest";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";

class SalaryRequestList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isDataReady: false, showRequestForm: false, rowKey: null, readOnly: true
        }
    }

    componentDidMount() {
        this.setState({isDataReady: false}, this.initialize);
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.dataItem_PersInfo.execute());
            await this.props.dispatch(this.props.dataItem_ReqList.execute({}, {withParams: true}));
            await this.props.dispatch(this.props.dataItem_Actions.execute());
        } catch (e) {
            this.props.dispatch(errorRaised(e));
        } finally {
            this.setState({isDataReady: true});
        }
    }

    createRequest = () => {
        this.setState({showRequestForm: true, rowKey: null, readOnly: false});
    }
    editRequest = (row, readOnly) => {
        const rowKey = this.props.dataItem_ReqList.getRowKey(row);
        this.setState({showRequestForm: true, rowKey: rowKey, readOnly: readOnly});
    }
    deleteRequest = async (rowIndex) => {
        try {
            await confirm(i18next.t("Salary_Request_List_1"));
            await this.props.dispatch(this.props.dataItem_ReqList.deleteRow(rowIndex));
            await this.props.dispatch(this.props.dataItem_Actions.refresh());
        } catch (e) {
        }
    }
    closeRequestForm = async (needRefresh) => {
        this.setState({showRequestForm: false, rowKey: null});
        if (needRefresh) {
            await this.refresh();
        }
    }
    refresh = async () => {
        await this.props.dispatch(this.props.dataItem_ReqList.refresh());
        await this.props.dispatch(this.props.dataItem_Actions.refresh());
    }
    renderButtons = () => {
        const actions = this.props.dataItem_Actions.getRow(0);
        return (
            actions._IsCanAddReq === 1 &&
            <div className="col-md-3">
                <button type="button" className="btn btn-regular -goahead"
                        onClick={this.createRequest}>
                    {i18next.t("Change")}
                </button>
            </div>
        );
    }

    renderGridCell = (cellParams) => {
        const readOnly = cellParams.row._IsCanUpdReq !== 1;
        if (cellParams.fieldInfo.Name === "Actions") {
            return (<div>
                {(cellParams.row._IsCanViewReq === 1 || cellParams.row._IsCanUpdReq === 1) &&
                    <button className="btn" type="button" style={{color: "brown"}}
                            title={i18next.t(readOnly ? "Salary_Request_List_3" : "EditRequest")}
                            onClick={() => this.editRequest(cellParams.row, readOnly)}>
                        <i className={readOnly ? "fas fa-eye" : "fas fa-edit"}/>&nbsp;
                    </button>}
                {cellParams.row._IsCanDelReq === 1 &&
                    <button className="btn" type="button" style={{color: "brown"}} title={i18next.t("RemoveStatement")}
                            onClick={() => this.deleteRequest(cellParams.rowIndex)}>
                        <i className="fas fa-trash-alt"/>&nbsp;
                    </button>}
            </div>);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    paramRender = (h) => {
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-2 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-10">
                                {h.ed(fn)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }
    paramRender2 = (h) => {
        return (<div className="row mb-2">
            {this.renderButtons()}
            <div className="col-md-9">
                <div className="row">
                    <div className="col-md-2 field-title text-nowrap mx-2">
                        {h.lbl("OnDateBeg")}
                    </div>
                    <div className="col-md-3">
                        {h.ed("OnDateBeg")}
                    </div>
                    <div className="col-md-2 field-title text-nowrap mx-2">
                        {h.lbl("OnDateEnd")}
                    </div>
                    <div className="col-md-3">
                        {h.ed("OnDateEnd")}
                    </div>
                </div>
            </div>
        </div>)
    }
    cellClick = (row, fieldInfo, e) => {
        if (fieldInfo.Name !== "Actions") {
            this.editRequest(row, true);
        }
    }

    render() {
        if (!this.state.isDataReady) return null;

        return <PlaceholderWrapper placeholderId="SalProject" title={i18next.t("Salary_Request_List_4")} collapsed={this.props.collapsed}
                                   showSplitterLine={false}>
            <PlaceholderWrapper placeholderId="20" title={i18next.t("Salary_Request_List_5")} collapsed={false} showInstruction={false}>
                <ComplexParam dataItem={this.props.dataItem_PersInfo} readOnly={true} showApplyButton={false}
                              showSearchBar={false}
                              renderParams={this.paramRender}/>
            </PlaceholderWrapper>
            <PlaceholderWrapper placeholderId="30" title={i18next.t("Salary_Request_List_6")} collapsed={false} showInstruction={false}>
                <div style={{maxWidth: "800px"}}>
                    <ComplexParam dataItem={this.props.dataItem_ReqList_Params} autoApplyParams={true}
                                  parentDataItem={this.props.dataItem_ReqList}
                                  showApplyButton={false}
                                  showSearchBar={false}
                                  renderParams={this.paramRender2}/>
                </div>
                <GridView dataItem={this.props.dataItem_ReqList}
                          renderCellEx={this.renderGridCell}
                          onCellClick={this.cellClick}
                          rowCursor="pointer"
                          readOnly={true}/>
            </PlaceholderWrapper>
            {this.state.showRequestForm && <SalaryRequest rowKey={this.state.rowKey} onClose={this.closeRequestForm}
                                                          addMode={this.state.rowKey === null}
                                                          readOnly={this.state.readOnly}
            />}
        </PlaceholderWrapper>
    }
}

SalaryRequestList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_PersInfo: PropTypes.object,
    dataItem_ReqList: PropTypes.object,
    dataItem_ReqList_Params: PropTypes.object,
    collapsed: PropTypes.bool,
    row: PropTypes.object
}
SalaryRequestList.defaultProps = {
    collapsed: true
};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_PersInfo: state.salaryProjectState.BspPersReq_POx_PersInfo,
        dataItem_ReqList: state.salaryProjectState.BspPersReq_POx_ListReq,
        dataItem_Actions: state.salaryProjectState.BspPersReq_POx_CalcReqAcion,
        dataItem_ReqList_Params: state.salaryProjectState.BspPersReq_POx_ListReq_Params
    }
}

export default connect(mapStateToProps)(SalaryRequestList)